import AddDepartmentalSubSpeciality from "../pages/diagnosis/master/departmentalSubSpeciality/add";
import ListDepartmentalSubSpeciality from "../pages/diagnosis/master/departmentalSubSpeciality/list";
import EditDepartmentalSubSpeciality from "../pages/diagnosis/master/departmentalSubSpeciality/edit";

import AddInvestigationCategory from "../pages/diagnosis/master/investigationCategory/add";
import ListInvestigationCategory from "../pages/diagnosis/master/investigationCategory/list";
import EditInvestigationCategory from "../pages/diagnosis/master/investigationCategory/edit";

import AddPathologyTest from "../pages/diagnosis/master/pathologyTest/add";
import ListPathologyTest from "../pages/diagnosis/master/pathologyTest/list";
import EditPathologyTest from "../pages/diagnosis/master/pathologyTest/edit";

import AddRadiologyTest from "../pages/diagnosis/master/radiologyTest/add";
import ListRadiologyTest from "../pages/diagnosis/master/radiologyTest/list";
import EditRadiologyTest from "../pages/diagnosis/master/radiologyTest/edit";

import AddPanel from "../pages/diagnosis/master/panel/add";
import ListPanel from "../pages/diagnosis/master/panel/list";
import EditPanel from "../pages/diagnosis/master/panel/edit";

import AddLabRegistrationEntry from "../pages/diagnosis/transaction/labRegistrationEntry/add";
import ListLabRegistrationEntry from "../pages/diagnosis/transaction/labRegistrationEntry/list";
import EditLabRegistrationEntry from "../pages/diagnosis/transaction/labRegistrationEntry/edit";

import AddLabRegistrationMultiple from "../pages/diagnosis/transaction/labRegistrationMultiple/add";
import ListLabRegistrationMultiple from "../pages/diagnosis/transaction/labRegistrationMultiple/list";
import EditLabRegistrationMultiple from "../pages/diagnosis/transaction/labRegistrationMultiple/edit";

export const diagnosisMasterRoutes = [
  // departmental-sub-speciality
  {
    path: `/diagnosis/master/departmental-sub-speciality/add`,
    Component: <AddDepartmentalSubSpeciality />,
    permission: "departmentalsubspeciality.add"
  },
  {
    path: `/diagnosis/master/departmental-sub-speciality/list`,
    Component: <ListDepartmentalSubSpeciality />,
    permission: "departmentalsubspeciality.list"
  },
  {
    path: `/diagnosis/master/departmental-sub-speciality/edit/:id`,
    Component: <EditDepartmentalSubSpeciality />,
    permission: "departmentalsubspeciality.edit"
  },

  // investigation-category
  {
    path: `/diagnosis/master/investigation-category/add`,
    Component: <AddInvestigationCategory />,
    permission: "investigationcategory.add"
  },
  {
    path: `/diagnosis/master/investigation-category/list`,
    Component: <ListInvestigationCategory />,
    permission: "investigationcategory.list"
  },
  {
    path: `/diagnosis/master/investigation-category/edit/:id`,
    Component: <EditInvestigationCategory />,
    permission: "investigationcategory.edit"
  },

  // pathology-test
  {
    path: `/diagnosis/master/pathology-test/add`,
    Component: <AddPathologyTest />,
    permission: "pathologytest.add"
  },
  {
    path: `/diagnosis/master/pathology-test/list`,
    Component: <ListPathologyTest />,
    permission: "pathologytest.list"
  },
  {
    path: `/diagnosis/master/pathology-test/edit/:id`,
    Component: <EditPathologyTest />,
    permission: "pathologytest.edit"
  },

  // radiology-test
  {
    path: `/diagnosis/master/radiology-test/add`,
    Component: <AddRadiologyTest />,
    permission: "radiologytest.add"
  },
  {
    path: `/diagnosis/master/radiology-test/list`,
    Component: <ListRadiologyTest />,
    permission: "radiologytest.list"
  },
  {
    path: `/diagnosis/master/radiology-test/edit/:id`,
    Component: <EditRadiologyTest />,
    permission: "radiologytest.edit"
  },

  // panel
  {
    path: `/diagnosis/master/panel/add`,
    Component: <AddPanel />,
    permission: "panel.add"
  },
  {
    path: `/diagnosis/master/panel/list`,
    Component: <ListPanel />,
    permission: "panel.list"
  },
  {
    path: `/diagnosis/master/panel/edit/:id`,
    Component: <EditPanel />,
    permission: "panel.edit"
  }
];

export const diagnosisTransactionRoutes = [
  // lab-registration-entry
  {
    path: `/diagnosis/transaction/lab-registration-entry/add`,
    Component: <AddLabRegistrationEntry />,
    permission: "labregistrationentry.add"
  },
  {
    path: `/diagnosis/transaction/lab-registration-entry/list`,
    Component: <ListLabRegistrationEntry />,
    permission: "labregistrationentry.list"
  },
  {
    path: `/diagnosis/transaction/lab-registration-entry/edit/:id`,
    Component: <EditLabRegistrationEntry />,
    permission: "labregistrationentry.edit"
  },

  // lab-registration-multiple
  {
    path: `/diagnosis/transaction/lab-registration-multiple/add`,
    Component: <AddLabRegistrationMultiple />,
    permission: "labregistrationmultiple.add"
  },
  {
    path: `/diagnosis/transaction/lab-registration-multiple/list`,
    Component: <ListLabRegistrationMultiple />,
    permission: "labregistrationmultiple.list"
  },
  {
    path: `/diagnosis/transaction/lab-registration-multiple/edit/:id`,
    Component: <EditLabRegistrationMultiple />,
    permission: "labregistrationmultiple.edit"
  }
];

export const diagnosisReportRoutes = [];
